import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e6d0c9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card",
  style: {"margin-bottom":"-95px","z-index":"1","background-color":"revert"}
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, null, -1))
const _hoisted_4 = { class: "card-toolbar flex-column align-items-end gap-3" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("天")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("周")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("月")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("   ")

import { MenuComponent } from "@/assets/ts/components";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ref, onMounted, reactive, computed } from "vue";
import { useStore } from "vuex";
import { parseTime } from "@/utils";
import Digram from "./components/Digram.vue";
import Detail from "./components/Detail.vue";
import ApiService from "@/core/services/ApiService";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const dataT = ref<any>(null);
const d = new Date();
d.setDate(d.getDate() - 7);
const filters = reactive({
  start_date: parseTime(d, "{y}-{m}-{d}"),
  stop_date: parseTime(new Date(), "{y}-{m}-{d}"),
  compare_start_date: "",
  compare_stop_date: "",
  dateType: "day", // 默认按天显示
  platform: [""],
  api: [""],
});
const start_stop_date = ref<any>([filters.start_date, filters.stop_date]);
const compare_start_stop_date = ref<any>([]);
const shortcuts = [
  {
    text: "昨天",
    value: () => {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return [date, date];
    },
  },
  {
    text: "最近7天",
    value: () => {
      const date = new Date();
      date.setDate(date.getDate() - 7);
      return [date, new Date()];
    },
  },
  {
    text: "最近15天",
    value: () => {
      const date = new Date();
      date.setDate(date.getDate() - 15);
      return [date, new Date()];
    },
  },
  {
    text: "最近30天",
    value: () => {
      const date = new Date();
      date.setDate(date.getDate() - 30);
      return [date, new Date()];
    },
  },
];

const compareShortcuts = [
  {
    text: "往前一周",
    value: () => {
      const start = new Date(filters.start_date as string);
      const stop = new Date(filters.stop_date as string);
      start.setDate(start.getDate() - 7);
      stop.setDate(stop.getDate() - 7);
      return [start, stop];
    },
  },
  // {
  //   text: "前两周",
  //   value: () => {
  //     const start = new Date(filters.start_date as string);
  //     const stop = new Date(filters.stop_date as string);
  //     start.setDate(start.getDate() - 14);
  //     stop.setDate(stop.getDate() - 14);
  //     return [start, stop];
  //   },
  // },
  // {
  //   text: "前三周",
  //   value: () => {
  //     const start = new Date(filters.start_date as string);
  //     const stop = new Date(filters.stop_date as string);
  //     start.setDate(start.getDate() - 21);
  //     stop.setDate(stop.getDate() - 21);
  //     return [start, stop];
  //   },
  // },
  {
    text: "往前一月",
    value: () => {
      const start = new Date(filters.start_date as string);
      const stop = new Date(filters.stop_date as string);
      start.setMonth(start.getMonth() - 1);
      stop.setMonth(stop.getMonth() - 1);
      return [start, stop];
    },
  },
  {
    text: "同期对比",
    value: () => {
      const start = new Date(filters.start_date as string);
      const stop = new Date(filters.stop_date as string);
      start.setFullYear(start.getFullYear() - 1);
      stop.setFullYear(stop.getFullYear() - 1);
      return [start, stop];
    },
  },
];

const items = ref<any>([]); // 当前站点的api地址

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("report.monitoring.report", [
    "report.monitoring.name",
  ]);

  ApiService.get("m/api/items").then(({ data }) => {
    items.value = data;
  });
});

const user = computed(() => {
  return store.getters.currentUser;
});

const disabledDate = (time: Date) => {
  return time.getTime() > Date.now();
};

const changeDate = function (v) {
  let s = new Date(v[0]);
  let e = new Date(v[1]);
  s.setDate(s.getDate() + 180);
  if (e < s) {
    filters.start_date = v[0];
    filters.stop_date = v[1];
  } else {
    ElMessage.warning("筛选范围过大会导致浏览器卡顿，请缩小范围查询！");
  }
};

const changeCompareDate = function (v) {
  if (v && v.length === 2) {
    filters.compare_start_date = v[0];
    filters.compare_stop_date = v[1];
  } else {
    filters.compare_start_date = "";
    filters.compare_stop_date = "";
  }
};

const changeType = (val, type) => {
  // 步骤1：处理数组第一个元素的条件
  let newArray: any = [...val]; // 先拷贝原数组，避免修改原数组
  // 判断：第一个元素为空 且 数组长度≥2
  if (newArray[0] === "" && newArray.length >= 2) {
    newArray.shift(); // 移除第一个元素
  }
  // 步骤2：检查是否存在空值，存在则更新为 [""]
  const hasEmptyValue = newArray.some((item) => item === "");
  if (hasEmptyValue) {
    newArray = [""];
  }

  if (newArray.length < 1) {
    newArray = [""];
  }

  filters[type] = newArray;

  // done
  dataT?.value?.setCurrent?.(1);
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_select, {
              modelValue: _unref(filters).platform,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).platform) = $event)),
              size: "small",
              placeholder: "平台",
              multiple: "",
              onChange: _cache[1] || (_cache[1] = 
              (val) => {
                changeType(val, 'platform');
              }
            )
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  value: "",
                  label: "所有平台"
                }),
                _createVNode(_component_el_option, {
                  value: "pc",
                  label: "pc"
                }),
                _createVNode(_component_el_option, {
                  value: "m",
                  label: "m"
                }),
                _createVNode(_component_el_option, {
                  value: "app",
                  label: "app"
                }),
                _createVNode(_component_el_option, {
                  value: "wap",
                  label: "wap"
                }),
                _createVNode(_component_el_option, {
                  value: "android",
                  label: "android"
                }),
                _createVNode(_component_el_option, {
                  value: "ios",
                  label: "ios"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_5,
            _createVNode(_component_el_select, {
              modelValue: _unref(filters).api,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).api) = $event)),
              size: "small",
              placeholder: "API",
              multiple: "",
              "collapse-tags": true,
              onChange: _cache[3] || (_cache[3] = 
              (val) => {
                changeType(val, 'api');
              }
            ),
              style: {"min-width":"150px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  value: "",
                  label: "所有API"
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (v, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    value: v,
                    label: v
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_6,
            _createVNode(_component_el_date_picker, {
              modelValue: start_stop_date.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((start_stop_date).value = $event)),
              type: "daterange",
              "range-separator": "到",
              "value-format": "YYYY-MM-DD",
              size: "small",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              clearable: false,
              onChange: changeDate,
              shortcuts: shortcuts,
              "disabled-date": disabledDate
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(filters).dateType,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filters).dateType) = $event)),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_button, { label: "day" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio_button, { label: "week" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio_button, { label: "month" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_10,
            _createVNode(_component_el_date_picker, {
              modelValue: compare_start_stop_date.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((compare_start_stop_date).value = $event)),
              type: "daterange",
              "range-separator": "到",
              "value-format": "YYYY-MM-DD",
              size: "small",
              "start-placeholder": "对比开始",
              "end-placeholder": "对比结束",
              clearable: "",
              onChange: changeCompareDate,
              shortcuts: compareShortcuts,
              "disabled-date": disabledDate
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createVNode(Digram, { filters: _unref(filters) }, null, 8, ["filters"]),
    _createVNode(Detail, {
      ref_key: "dataT",
      ref: dataT,
      filters: _unref(filters)
    }, null, 8, ["filters"])
  ], 64))
}
}

})